module.exports = __webpack_public_path__ + "img/will-funeral.474f9752.svg";